export const PLATFORM_FEATURES = {
  treino: 'treino',
  bookings: 'bookings',
  billing: 'billing',
  workServices: 'work-services',
  goods: 'goods',
  livePickup: 'live-pickup',
  suggestions: 'suggestions',
  school: 'school',
  receivementsPanel: 'receivements-panel',
  /**
   * Public self-registration: the "registration link" screen and the counter
   * recovery of what was filled in through it. On only for the brands the
   * registration Worker serves — it answers 403 to any other.
   */
  publicRegistration: 'public-registration',
  /**
   * The ato console (`/support`) and its permission group in Configurações →
   * Funções (Atendimento, 325–333). On only for the brands whose app registers
   * the route.
   */
  support: 'support',
} as const;

export type PlatformFeature = (typeof PLATFORM_FEATURES)[keyof typeof PLATFORM_FEATURES];
export type EnabledPlatformFeatures = readonly PlatformFeature[];

export const hasPlatformFeature = (
  enabledPlatformFeatures: EnabledPlatformFeatures | null | undefined,
  feature: PlatformFeature
): boolean => enabledPlatformFeatures?.includes(feature) ?? false;

export const arePlatformFeaturesEnabled = (
  enabledPlatformFeatures: EnabledPlatformFeatures | null | undefined,
  features?: readonly PlatformFeature[] | null
): boolean => features?.every((feature) => hasPlatformFeature(enabledPlatformFeatures, feature)) ?? true;

/**
 * OR-semantics counterpart of {@link arePlatformFeaturesEnabled}: passes when no
 * features are required, or when at least one of them is enabled.
 */
export const isAnyPlatformFeatureEnabled = (
  enabledPlatformFeatures: EnabledPlatformFeatures | null | undefined,
  features?: readonly PlatformFeature[] | null
): boolean => !features?.length || features.some((feature) => hasPlatformFeature(enabledPlatformFeatures, feature));

export const isPlatformFeatureVisible = (
  enabledPlatformFeatures: EnabledPlatformFeatures | null | undefined,
  feature: PlatformFeature,
  runtimeAllowed = true
): boolean => runtimeAllowed && hasPlatformFeature(enabledPlatformFeatures, feature);
